import React, { useEffect, useState } from 'react';
import { TABLE_NAME } from '@cp/pages/TeamLeadDashboard/interface';
import NaviTable from '@cp/components/NaviTable/NaviTable';
import { NaviTableColumnDef, PaginationOptions } from '@cp/components/NaviTable/interfaces';
import { noop } from '@utils/common';
import axiosInstance, { ApiKeys, getApiUrl } from '@cp/utils/ApiHelper';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { getQueryString } from '@cp/pages/TeamLeadDashboard';
import { useLocation, useSearchParams } from 'react-router-dom';
import cx from 'classnames';
export const AGENCY_CAPPING_COL_DEFS: NaviTableColumnDef<any, any>[] = [
  {
    accessorKey: 'state',
    header: 'State',
    size: 180,
    tooltip: true
  },
  {
    accessorKey: 'district',
    header: 'District',
    size: 180,
    tooltip: true
  },
  {
    accessorKey: 'cappingValueDpd1To30',
    header: 'DPD 1-30',
    size: 180,
    cell: info => {
      return info.getValue() === null ? 'No capping' : info.getValue();
    },
    tooltip: true
  },
  {
    accessorKey: 'cappingValueDpd31To180',
    header: 'DPD 31-180',
    size: 180,
    cell: info => {
      return info.getValue() === null ? 'No capping' : info.getValue();
    },
    tooltip: true
  },
  {
    accessorKey: 'cappingValueDpd180Plus',
    header: 'DPD 180+',
    size: 180,
    cell: info => {
      return info.getValue() === null ? 'No capping' : info.getValue();
    },
    tooltip: true
  }
];
function Table() {
  const [pageData, setPageData] = useState([]);
  const [loading, setLoading] = useState(false);
  const selectedAgency = useSelector((state: RootState) => state.agencyCapping.selectedAgency);
  const selectedState = useSelector((state: RootState) => state.agencyCapping.selectedState);
  const [totalElements, setTotalElements] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const queryString = getQueryString();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const getData = async (pageNo: number, pageSize: number) => {
    if (!selectedAgency) {
      setPageData([]);
      setTotalElements(0);
      return;
    }
    setLoading(true);
    const url = getApiUrl(ApiKeys.AGENCY_CAPPING_DASHBOARD_TABLE, null, {
      agencyCode: selectedAgency,
      state: selectedState ? selectedState : 'ALL',
      pageNo: pageNo,
      pageSize: pageSize
    });
    axiosInstance
      .get(url)
      .then(response => {
        setPageData(response.data?.agencyCapping);
        setTotalElements(response.data?.pages?.totalElements);
        setLoading(false);
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    getData(parseInt(queryString?.pageIndex || '0'), parseInt(queryString?.pageSize || '0'));
  }, [location]);

  useEffect(() => {
    setSearchParams(
      {
        'pageSize*teamLead': '10',
        'pageIndex*teamLead=1': '1'
      },
      { replace: true }
    );
  }, [selectedAgency, selectedState]);

  return (
    <div className="h-[calc(100vh-280px)] mt-4">
      <NaviTable
        tableName={TABLE_NAME}
        columns={AGENCY_CAPPING_COL_DEFS}
        data={pageData || []}
        totalElements={totalElements || 0}
        loading={loading}
        enableRowClick={() => true}
        onRowClick={noop}
        defaultPaginationState={{
          pageIndex: 0,
          pageSize: 50
        }}
        paginationType={PaginationOptions.SERVER_SIDE}
        emptyDataComponent={
          <div
            className={cx('flex justify-center items-center h-full text-[--grayscale-2] text-sm')}
          >
            {' '}
            {selectedAgency ? 'No data available' : 'Please select an agency to view data'}
          </div>
        }
      />
    </div>
  );
}

export default Table;
